<template>
  <div class="container">
    <img class="bg_img" :class="{bg_opc:current === 0}" :src="`${$cdn}bg/${isMobile?'':'pc-'}bg1.jpg`" alt="">
    <img class="bg_img" :class="{bg_opc:current === 1}" :src="`${$cdn}bg/${isMobile?'':'pc-'}bg2.jpg`" alt="">
    <img class="bg_img" :class="{bg_opc:current === 2}" :src="`${$cdn}bg/${isMobile?'':'pc-'}bg3.jpg`" alt="">

    <div class="home_btn" @click="videoVisble = true">
      <p>全景校园 Virtual Tour</p>
      <button :style="{backgroundImage:`url(${$cdn}icon/tiyan.png)`}">
      </button>
    </div>
    <img class="logo" :src="`${$cdn}icon/xiaoxun.png`" alt="">
    <img class="logo logo2" :src="`${$cdn}icon/logo.png`" alt="">

    <div class="initVideo" v-if="videoVisble">
      <video controls autoplay loop :src="`${$cdn}video/introduce.mp4`"></video>
      <div class="home_btn" @click="tiaoguo">
        <button :style="{backgroundImage:`url(${$cdn}icon/tiaoguo.png)`}">
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import browser from '@/utils/browser'

export default {
  name: 'Home',
  data(){
    return{
      videoVisble:false,
      current:0,
      isMobile: browser.mobile
    }
  },
  components: {
    
  },
  methods:{
    tiaoguo(){
      this.$emit('audio',true)
      this.$router.push({path:'list'})
    }
  },
  mounted(){
    setInterval(() => {
      if (this.current >= 2) {
        this.current = 0
      }
      else{
        this.current += 1
      }
    }, 3000);
  }
}
</script>

<style lang="less" scoped>
.container{
  width: 100%;
  height: 100%;
  margin: 0 auto;
  position: relative;
  .bg_img{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 100%;
    transition: all ease .5s;
    opacity: 0;
    z-index: -1;
  }

  .bg_opc{
    opacity: 1;
  }

  
  .logo{
    position: absolute;
    left: 60px;
    top: 30px;
    z-index: 99999;
    width: 300px;
  }
  .logo2{
    left: unset;
    top: 30px;
    right: 30px;
    width: 200px;
  }
  .home_btn{
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 6%;
    z-index: 9999;
    font-size: 0;
    color: #fff;
    p{
      color: #fff;
      font-size: 18px;
      letter-spacing: 1px;
      margin-bottom: 4px;
      text-shadow: 0 5px 10px rgba(0, 0, 0, 1);
      text-align: center;
    }
    button{
      font-size: 18px;
      width: calc(415px * 0.6);
      height: calc(155px * 0.6);
      border-radius: 4px;
      cursor: pointer;
      color: #fff;
      letter-spacing: 1px;
      padding: 8px 40px;
      font-weight: bold;
      border: none;
      background-repeat: no-repeat;
      background-size: cover;
      background-color: rgba(0, 0, 0, 0);
      span{
        margin-top: 4px;
        font-size: 14px;
        font-weight: normal;
        display: inline-block;
      }
    }
  }
  .initVideo{
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: url('https://4d-tjw.oss-cn-shenzhen.aliyuncs.com/uic/bg/pc-video_bg.jpg') center;
    background-size: cover;
    z-index: 99999;
    video{
      width: 50%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
    }
  }
}

@media screen and (max-width: 500px) {
  .container{
    max-width: 500px;
    .logo{
      width: 40%;
      left: 20px;
      top: 30px;
    }
    .logo2{
      right: 10px;
      left: unset;
      width: 38%;
    }
    .home_btn{
      p{
        font-size: 12px;
      }
      button{
        width: calc(415px * 0.4);
        height: calc(155px * 0.4);
      }
    }
    .initVideo{
      background: url('https://4d-tjw.oss-cn-shenzhen.aliyuncs.com/uic/bg/video_bg.jpg') center;
      video{
        width: 100%;
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
      }
    }
  }
}
</style>